import { render } from "./QueueScrapForm.vue?vue&type=template&id=196a482b&scoped=true"
import script from "./QueueScrapForm.vue?vue&type=script&lang=js"
export * from "./QueueScrapForm.vue?vue&type=script&lang=js"

import "./QueueScrapForm.vue?vue&type=style&index=0&id=196a482b&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a482b"]])

export default __exports__